<!-- @format -->

<template>
  <!-- <Header /> -->
  <main>
    <div class="w-layout-hflex header is--dark is--policy">
      <div class="w-layout-hflex header--wrapper">
        <a href="/" class="brand w-inline-block">
          <div class="sign--wrapper">
            <div class="toggle--wrapper">
              <img
                src="@/assets/img/swipez--toggle--shape.svg"
                loading="lazy"
                alt=""
                class="sign--toggle"
              />
            </div>
            <img
              src="@/assets/img/swipez--sqaure--shape.svg"
              loading="lazy"
              alt=""
              class="sign--square"
            />
          </div>
          <div class="w-layout-hflex swipez--text--wrapper">
            <img
              src="@/assets/img/Swipez--text--logo.svg"
              loading="lazy"
              alt="Swipez logotype"
              class="swipez--text--logo"
            />
          </div>
        </a>
        <div data-w-id="2bc61cb3-c810-a306-521f-0ec5dbac2c62" class="cta--wrapper is--policy">
          <a href="/" class="button w-inline-block">
            <div>{{ $t("Back to website") }}</div>
          </a>
        </div>
      </div>
    </div>
    <div data-w-id="72fa98d1-19f4-83d1-4385-6e838d8fa27b" class="hero is--policy">
      <div class="w-layout-hflex global--padding">
        <div class="global--wrapper is--footer">
          <div class="w-layout-vflex policy--wrapper">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </main>
  <Footer />
</template>

<script setup lang="ts">
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import { useI18n } from "vue-i18n";
import { onMounted, ref } from "vue";
const { locale } = useI18n();
const curLang = ref("cz");
onMounted(async () => {
  curLang.value = localStorage.getItem("locale") || "cz";
  locale.value = curLang.value;
});
</script>

<style lang="scss">
.global--padding {
  p {
    color: #fff;
  }

  ul {
    li::marker {
      color: #fff;
      font-weight: bold;
    }
  }

  h2,
  h3 {
    padding-top: 1em;
    padding-bottom: 0.5em;
    color: #fff;
    // text-align: left !important;
  }

  ol {
    margin-left: 20px;

    li::marker {
      color: #fff;
      font-weight: bold;
      font-size: 3em;
      font-family: Made Outer Sans, sans-serif;
    }

    &.litle li::marker {
      font-size: 14px;
    }
  }
}
</style>
